/**
 * Section-scoped before/after comparison slider.
 */
(() => {
  'use strict';

  const tagName = 'comparison-slider';
  if (customElements.get(tagName)) return;

  class ComparisonSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.sliderOverlay = this.querySelector('.comparison-slider__overlay');
      this.sliderLine = this.querySelector('.comparison-slider__line');
      this.sliderInput = this.querySelector('.comparison-slider__input');
      if (!this.sliderOverlay || !this.sliderLine || !this.sliderInput) return;

      this.handleChangeBound = this.handleChange.bind(this);
      this.sliderInput.addEventListener('input', this.handleChangeBound);
      this.initialized = true;
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.sliderInput.removeEventListener('input', this.handleChangeBound);
      this.handleChangeBound = null;
      this.initialized = false;
    }

    handleChange(event) {
      const value = event.currentTarget.value;
      this.sliderOverlay.style.width = `${value}%`;
      this.sliderLine.style.left = `${value}%`;
    }
  }

  customElements.define(tagName, ComparisonSlider);
})();
